import { autofocusAttr } from 'hooks/useAutofocusAttr';

/**
 * NetworkEditingPopup (project/view/network_editing_disclaimer_popup.js +
 * network_editing_revoke_popup.js → network_editing_{disclaimer,revoke}_popup
 * .tmpl): the confirmation shown by the "Network Users Editing" checkbox
 * BEFORE anything is persisted.
 *
 * - `grant` (check): the disclaimer, interpolating the project's mfg_name;
 *   confirm button "Grant Editing Access"; wrapper carries the extra
 *   `grant-network-editing-popup` class.
 * - `revoke` (uncheck): the revocation notice; confirm button
 *   "Revoke Editing Access".
 * - Confirm → caller commits (PATCH network_editing_enabled); Cancel → caller
 *   reverts with NO HTTP (Backbone flips the checkbox back).
 * - Confirm carries autofocus="true" (ENTER confirms), per the templates.
 */
interface NetworkEditingPopupProps {
  mode: 'grant' | 'revoke';
  mfgName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const NetworkEditingPopup = ({
  mode,
  mfgName,
  onConfirm,
  onCancel,
}: NetworkEditingPopupProps) => (
  <div className="popup-wrapper create-popup active">
    <div
      className={`popup-content network-editing-popup${
        mode === 'grant' ? ' grant-network-editing-popup' : ''
      }`}
    >
      <h2 className="popup-heading">
        {mode === 'grant'
          ? 'Grant Network Users Editing Access'
          : 'Revoke Network Users Editing Access'}
      </h2>
      <div className="popup-content-part project-popup-content-part">
        {mode === 'grant' ? (
          <p>
            By clicking on GRANT EDITING ACCESS, you acknowledge and agree that
            you are granting "{mfgName}" and its authorized Network Users
            permission to access, modify and edit this particular project,
            including its associated air handling unit(s).
            <br />
            <br />
            You understand that this access allows "{mfgName}" personnel (all
            Network Users) to make changes necessary for support,
            standardization or project advancement.
            <br />
            By proceeding, you confirm that you have reviewed and accepted this
            authorization.
          </p>
        ) : (
          <p>
            By clicking on REVOKE EDITING ACCESS, you will revoke the right of
            all Network Users to have editing access to this project and its
            associated air handling unit(s).
          </p>
        )}
      </div>
      <div className="popup-control-buttons">
        <button
          ref={autofocusAttr}
          className="save default-btn highlighted-btn"
          name="confirm_btn"
          onClick={onConfirm}
        >
          {mode === 'grant' ? 'Grant Editing Access' : 'Revoke Editing Access'}
        </button>
        <button className="not-highlighted-btn" name="cancel_btn" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export default NetworkEditingPopup;
